import { render, staticRenderFns } from "./ShareEdit.vue?vue&type=template&id=978db54a&scoped=true&"
import script from "./ShareEdit.vue?vue&type=script&lang=js&"
export * from "./ShareEdit.vue?vue&type=script&lang=js&"
import style0 from "./ShareEdit.vue?vue&type=style&index=0&id=978db54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978db54a",
  null
  
)

export default component.exports